import { useLocation, useParams } from "react-router-dom";
import { TMobileRouterPath } from "./router";

export const useResolveToBasePath = () => {
  const location = useLocation();
  const params = useParams();
  let route = location.pathname;
  Object.entries(params).forEach(([k, v = ""]) => {
    route = route.replace(v, `:${k}`);
  });
  return route as TMobileRouterPath;
};
